import { SeoMapper } from '@search/router/src';

export const furnitureMapper = new SeoMapper('furnitureMapper', {
    UNKNOWN: 'UNKNOWN',
    NO: 'NO',
    KITCHEN: 'KITCHEN',
    ALL: 'ALL'
} as const);
